import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/axios'
import './plugins/bootstrap-vue'
import App from './App.vue'
import './plugins/bootstrap-vue'
import { BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.min.css'

import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import 'font-awesome/css/font-awesome.css';
import router from './router'
import i18n from './i18n'

import '@/assets/styles/common.css';

import Amplify from "aws-amplify";
import aws_exports from "./aws-exports";
import {
  applyPolyfills,
  defineCustomElements,
} from "@aws-amplify/ui-components/loader";

Amplify.configure(aws_exports);
applyPolyfills().then(() => {
  defineCustomElements(window);
});

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

// default expire time: 1 day, https://www.npmjs.com/package/vue-cookies
Vue.use(require('vue-cookies'))

Vue.use(BootstrapVueIcons)
Vue.use(Antd)
Vue.prototype.$EventBus = new Vue()
Vue.config.productionTip = false
Vue.prototype.$aTableScroll = { x: 'max-content' }

Vue.prototype.$emailRegExp = '^[A-Za-z0-9_-\\u4e00-\\u9fa5]+(\\.[A-Za-z0-9_-\\u4e00-\\u9fa5]+)*@[a-zA-Z0-9_-]+(\\.[a-zA-Z0-9_-]+)+$'

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')

i18n.locale = localStorage.getItem('cl_admin_language') || 'en_US';

// set locale cache
// const cdtLanguageList = ['en_US', 'zh_TW', 'zh_CN']
// if (!cdtLanguageList.includes(localStorage.getItem('language'))) {
//   localStorage.setItem('language', 'zh_TW')
// }
// i18n.locale = localStorage.getItem('language') || i18n.locale || 'zh_TW'
// localStorage.setItem('language', i18n.locale)